import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import {
  selectMenuItem,
  selectMenuItems,
} from "@store/menuItem/menuItemReducer";
import { MenuItem } from "@dto/MenuItem";
import { setMenuItemAction } from "@store/menuItem/actions/setMenuItemAction";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
import { selectIsHeaderVisible } from "@store/app/appReducer";

import "./MenuItems.css";
import { useMatch, useSearchParams } from "react-router";

const MenuItems = () => {
  const menuItems = useAppSelector(selectMenuItems);
  const selectedMenuItem = useAppSelector(selectMenuItem);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isHeaderVisible = useAppSelector(selectIsHeaderVisible);
  const isPlanScreen = useMatch("/plan");
  const [searchParams] = useSearchParams();
  const isMobileMapView = searchParams.get("view") === "map";

  const handlePress = useCallback(
    (menuItem: MenuItem) => (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      event.stopPropagation();
      navigate(menuItem.analyticsPath);
      dispatch(setMenuItemAction(menuItem));
    },
    [dispatch, navigate],
  );

  return (
    <div
      className={
        isPlanScreen || !isHeaderVisible || isMobileMapView
          ? "menu-items-component hide-menu-items"
          : "menu-items-component"
      }>
      {menuItems?.map((menuItem) => {
        return (
          <a
            href={menuItem.analyticsPath}
            key={menuItem.id}
            className={`menu-item${
              selectedMenuItem?.id === menuItem.id ? " active" : ""
            }`}
            onClick={handlePress(menuItem)}>
            <img
              src={menuItem.iconUrl ?? menuItem.inactiveIconUrl}
              width={12}
              height={12}
            />
            <span className="label">{menuItem.name}</span>
          </a>
        );
      })}
    </div>
  );
};

export { MenuItems };
